import React from 'react'
import cl from 'classnames'
import styles from './side-menu-section-button.module.scss'
import { ReactSvgComponent, StyleProps } from '@touche-lts/panel-ui/dist'
import { Button } from '@touche-lts/panel-ui/dist/components/shared/button'
import { Text1 } from '@touche-lts/panel-ui/dist/components/shared/text1'

export interface SideMenuSectionButtonProps extends StyleProps {
  icon: ReactSvgComponent
  label: string
  isSelected: boolean
  onClick: () => void
  notAllowedForLoggedUser: boolean
  disabled?: boolean
}

const SideMenuSectionButtonComponent = (props: SideMenuSectionButtonProps) => {
  const {
    className,
    style,
    notAllowedForLoggedUser,
    icon: Icon,
    label,
    onClick,
    isSelected,
    disabled
  } = props

  if (notAllowedForLoggedUser) return null

  return (
    <Button
      preset='icon'
      className={cl(
        styles.button,
        {
          [styles.selected]: isSelected
        },
        className
      )}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.iconContainer}>
        <Icon />
      </div>
      <Text1 bold>{label}</Text1>
    </Button>
  )
}

SideMenuSectionButtonComponent.defaultProps = {} as SideMenuSectionButtonProps

const SideMenuSectionButton = SideMenuSectionButtonComponent
export { SideMenuSectionButton }
